import { Theme, useTheme } from "@mui/material";
import React from "react";
import { createGlobalStyle } from "styled-components";

interface ICSSOverrideProps {
  overrideCSS?: string;
}

// TODO: Add more scoping
const GlobalStyle = createGlobalStyle<{ overrideCSS?: string; aquariusTheme: Theme }>`
  #smartrr_wrapper,
  #smartrr_header,
  #smartrr_inner,
  .smartrr-portal-modal-wrapper{
    ${props => props.aquariusTheme.modernOverrideCSS || ""}
  }

  #smartrr_header,
  #smartrr_inner,
  #smartrr_wrapper{
    background-color: ${props => props.aquariusTheme.modernPageBackground};
    outline: none;
    -webkit-font-smoothing: antialiased !important;  
  }
  #smartrr_wrapper{
    min-height: 90vh;
  }

  *:focus-within, *:focus{
    outline:none !important;
    box-shadow: none !important;
  }

   html{ 
    scroll-behavior: smooth;
  }


  /* DIVIDER */
  & hr{  
    background-color: ${props => props.aquariusTheme.modernLineDividers};
    margin: 0px;
    width: 100%;
    height: 1px;
  }

  /* Prevents outside styling from hiding :empty div */
  .dot:empty{
    display: flex !important;
  }

  /* Rule is required for input text to appear on Safari */
  input{
    line-height: 1 !important;
  }


  .smartrr-hidden, .smartrr-portal-hidden{
    display: none !important;
  }

  /* Removing default browser dropdown arrow */
  select::-ms-expand {
    display: none;
}
  /* FALLBACK IMAGE STYLE OVERRIDES */
  .smartrr-portal-product-image-container {
    background-color: transparent;
    & [class*="fallback-image"]{
      background-color: ${props => props.aquariusTheme.modernLineDividers};
      border:0px;
      height: 100%;
      width: 100%;
    }
  }
  
  ${
    process.env.NODE_ENV === "production"
      ? ""
      : `
      html {
        padding-bottom: 0 !important;
      }
      #smartrr_account {
        margin-top: -20px;
      }

      #admin-bar-iframe {
        display: none !important;
      }

      #preview-bar-iframe {
        display: none !important;
      }
    `
  }
`;

export function OverrideCSS({ overrideCSS }: ICSSOverrideProps): JSX.Element {
  const theme = useTheme();

  return (
    <React.Fragment>
      <GlobalStyle overrideCSS={overrideCSS} aquariusTheme={theme} />
    </React.Fragment>
  );
}
